module.exports = __webpack_public_path__ + "img/button-fvckrender.fa1eacdb.png";